module.exports = __webpack_public_path__ + "img/emkf-2014-2020-est-el-v-100.72e45448.jpg";